// Hardcoded for now — no production deploy URL is available as an env
// var, and the canonical public origin is stable. Swap this for an env
// var lookup once REACT_APP_PUBLIC_SITE_URL is wired in.
export const PUBLIC_SITE_BASE = "https://www.leechiu.com";

// Mapping of CMS collection → public detail-page path. Only collections
// that have a public detail page on nextjsprojv1 belong here.
const COLLECTION_TO_PATH = {
  blogs: "/blogs",
  news: "/news",
  insights: "/market-insights",
  careers: "/careers",
  leaders: "/executive-leadership",
};

/**
 * Build the canonical public URL for a CMS-managed doc.
 * Prefers the editable `slug`, falls back to the Firestore doc id —
 * matches the slug-or-id resolution on the public site.
 *
 *   publicArticleUrl("blogs", { slug: "q4-outlook" })
 *     // → https://www.leechiu.com/blogs/q4-outlook
 *   publicArticleUrl("news",  { id: "abc123" })
 *     // → https://www.leechiu.com/news/abc123
 *
 * Returns null if the collection is unknown or no segment is available.
 */
export function publicArticleUrl(collection, doc) {
  const path = COLLECTION_TO_PATH[collection];
  if (!path) return null;
  const segment = doc?.slug || doc?.id;
  if (!segment) return null;
  return `${PUBLIC_SITE_BASE}${path}/${segment}`;
}

/** Build a public URL for a fixed page path (e.g. a service page). */
export function publicPageUrl(path) {
  if (!path) return PUBLIC_SITE_BASE;
  return `${PUBLIC_SITE_BASE}${path.startsWith("/") ? path : `/${path}`}`;
}
